import { render, staticRenderFns } from "./page-content-wysiwg-content.vue?vue&type=template&id=b909fdbc&scoped=true"
import script from "./page-content-wysiwg-content.vue?vue&type=script&lang=js"
export * from "./page-content-wysiwg-content.vue?vue&type=script&lang=js"
import style0 from "./page-content-wysiwg-content.vue?vue&type=style&index=0&id=b909fdbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b909fdbc",
  null
  
)

export default component.exports